import "./App.css";
import { BrowserRouter } from "react-router-dom";

import { Amplify } from "aws-amplify";
import { useContext, useEffect } from "react";
import PublicRoutes from "./Routes/publicRoutes";
import PrivateRoutes from "./Routes/privateRoutes";
import Clarity from "@microsoft/clarity";

import TagManager from "react-gtm-module";
import ConfigureContext from "./store/ConfigureContext";
import ChatWidget from "./Features/Chatbot/ChatWidget";
import GlobalUploadWidget from "./GlobalComponents/UploadWidget/GlobalUploadWidget";

// const { AES, enc } = require("crypto-js");
// const { decrypt, encrypt } = AES;
// const key = "rocon#*34!32%";

function setFavicon(url) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
}

function App() {
  const { cognitoId, appClientId } = useContext(ConfigureContext);

  let domain = window.location.hostname;
  domain =
    domain === "localhost" ? process.env.REACT_APP_METADATA_DOMAIN : domain;

  // Set dynamic title
  useEffect(() => {
    document.title =
      domain === process.env.REACT_APP_FRONTEND_DOMAIN
        ? "Rocon Hosting Portal - A TekYantra Product"
        : "Hosting Portal";
  }, [domain]);

  // Set dynamic favicon
  useEffect(() => {
    const appConfig = JSON.parse(localStorage.getItem("appConfig") || "{}");
    const appLogo = appConfig.icon;
    if (appLogo) {
      setFavicon(appLogo);
    }
  }, []);

  // Configure Amplify if credentials exist
  if (cognitoId && appClientId) {
    Amplify.configure({
      Auth: {
        Cognito: {
          REGION: "us-west-2",
          userPoolId: cognitoId,
          userPoolClientId: appClientId,
          authenticationFlowType: "USER_PASSWORD_AUTH",
        },
      },
    });
  }

  // GTM integration
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GA_TRACKING_ID,
  };
  TagManager.initialize(tagManagerArgs);

  // Microsoft Clarity integration.
  const projectId = process.env.REACT_APP_MICROSOFT_CLARITY_ID;
  Clarity.init(projectId);

  return (
    <BrowserRouter>
      <PublicRoutes />
      <PrivateRoutes />
      <ChatWidget />
      <GlobalUploadWidget />
    </BrowserRouter>
  );
}

export default App;
